import { capitalizer } from '@s/helper/utils'
const countryList = [
  'AUSTRALIA',
  // 'AFGHANISTAN',
  // 'ALBANIA',
  'ALGERIA',
  'AMERICAN SAMOA',
  'ANDORRA',
  'ANGOLA',
  'ANGUILLA',
  'ANTARCTICA',
  'ANTIGUA AND BARBUDA',
  'ARGENTINA',
  'ARMENIA',
  'ARUBA',
  'AUSTRIA',
  'AZERBAIJAN',
  'BAHAMAS',
  'BAHRAIN',
  'BANGLADESH',
  'BARBADOS',
  'BELARUS',
  'BELGIUM',
  'BELIZE',
  'BENIN',
  'BERMUDA',
  'BHUTAN',
  'BOLIVIA',
  'BOSNIA AND HERZEGOVINA',
  'BOTSWANA',
  'BOUVET ISLAND',
  'BRAZIL',
  'BRITISH IND OCEAN TERRITORY',
  'BRUNEI DARUSSALAM',
  'BULGARIA',
  'BURKINA FASO',
  'BURUNDI',
  'CAMBODIA',
  'CAMEROON',
  'CANADA',
  'CAPE VERDE',
  'CENTRAL AFRICAN REPUBLIC',
  'CHAD',
  'CHILE',
  'CHINA',
  'CHRISTMAS ISLAND',
  'COCOS (KEELING) ISLANDS',
  'COLOMBIA',
  'COMOROS',
  'CONGO',
  // 'CONGO, THE DEMOCRATIC REPUBLIC OF THE',
  'COOK ISLANDS',
  'COSTA RICA',
  'COTE D\'IVOIRE',
  'CROATIA',
  'CUBA',
  'CYPRUS',
  'CZECH REPUBLIC',
  'DENMARK',
  'DJIBOUTI',
  'DOMINICA',
  'DOMINICAN REPUBLIC',
  'ECUADOR',
  'EGYPT',
  'EL SALVADOR',
  'EQUATORIAL GUINEA',
  'ERITREA',
  'ESTONIA',
  'ETHIOPIA',
  'FALKLAND ISLAND (MALVINAS)',
  'FAROE ISLANDS',
  'FIJI',
  'FINLAND',
  'FRANCE',
  'FRENCH GUIANA',
  'FRENCH POLYNESIA',
  'FRENCH SOUTHERN TERRITORIES',
  'GABON',
  'GAMBIA',
  'GEORGIA',
  'GERMANY',
  'GHANA',
  'GIBRALTAR',
  'GREECE',
  'GREENLAND',
  'GRENADA',
  'GUADELOUPE',
  'GUAM',
  'GUATEMALA',
  'GUINEA',
  // 'GUINEA-BISSAU',
  'GUYANA',
  // 'HAITI',
  'HEARD ISLAND AND MCDONALD ISLANDS',
  'HOLY SEE (VATICAN CITY STATE)',
  'HONDURAS',
  'HONG KONG',
  'HUNGARY',
  'ICELAND',
  'INDIA',
  'INDONESIA',
  // 'IRAN (ISLAMIC REPUBLIC OF)',
  // 'IRAQ',
  'IRELAND',
  'ISRAEL',
  'ITALY',
  'JAMAICA',
  'JAPAN',
  'JORDAN',
  'KAZAKHSTAN',
  'KENYA',
  'KIRIBATI',
  // 'KOREA, DEMOCRATIC PEOPLE\'S REPUBLIC OF',
  'KOREA, REPUBLIC OF',
  'KUWAIT',
  'KYRGYZSTAN',
  'LAO PEOPLE\'S DEMOCRATIC REPUBLIC',
  'LATVIA',
  // 'LEBANON',
  'LESOTHO',
  'LIBERIA',
  // 'LIBYAN ARAB JAMAHIRIYA',
  'LIECHTENSTEIN',
  'LITHUANIA',
  'LUXEMBOURG',
  'MACAO',
  'MACEDONIA',
  'MADAGASCAR',
  'MALAWI',
  'MALAYSIA',
  'MALDIVES',
  // 'MALI',
  'MALTA',
  'MARIANAS ISLANDS',
  'MARTINIQUE',
  'MAURITANIA',
  'MAURITIUS',
  'MAYOTTE',
  'MEXICO',
  'MICRONESIA, FEDERATED STATES OF',
  'MOLDOVA, REPUBLIC OF',
  'MONACO',
  'MONGOLIA',
  'MONTENEGRO',
  'MONTSERRAT',
  'MOROCCO',
  'MOZAMBIQUE',
  // 'MYANMAR',
  'NAMIBIA',
  'NAURU',
  'NEPAL',
  'NETHERLANDS',
  'NETHERLANDS ANTILLES',
  'NEW CALEDONIA',
  'NEW ZEALAND',
  // 'NICARAGUA',
  'NIGER',
  'NIGERIA',
  'NIUE',
  'NORFOLK ISLAND',
  'NORTHERN MARIANA ISLANDS',
  'NORWAY',
  'OMAN',
  // 'PAKISTAN',
  'PALAU',
  // 'PALESTINIAN TERRITORY',
  // 'PANAMA',
  'PAPUA NEW GUINEA',
  'PARAGUAY',
  'PERU',
  // 'PHILIPPINES',
  'PITCAIRN',
  'POLAND',
  'PORTUGAL',
  'PUERTO RICO',
  'QATAR',
  'REUNION',
  'ROMANIA',
  // 'RUSSIAN FEDERATION',
  'RWANDA',
  'SAINT HELENA',
  'SAINT KITTS AND NEVIS',
  'SAINT LUCIA',
  'SAINT PIERRE AND MIQUELON',
  'SAINT VINCENT AND THE GRENADINES',
  'SAMOA',
  'SAN MARINO',
  'SAO TOME AND PRINCIPE',
  'SAUDI ARABIA',
  'SENEGAL',
  'SERBIA',
  'SEYCHELLES',
  'SIERRA LEONE',
  'SINGAPORE',
  'SLOVAKIA',
  'SLOVENIA',
  'SOLOMON ISLANDS',
  // 'SOMALIA',
  'SOUTH AFRICA',
  'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS',
  'SPAIN',
  'SRI LANKA',
  'SUDAN',
  'SURINAME',
  'SVALBARD AND JAN MAYEN',
  'SWAZILAND',
  'SWEDEN',
  'SWITZERLAND',
  // 'SYRIAN ARAB REPUBLIC',
  'TAIWAN, PROVINCE OF CHINA',
  'TAJIKISTAN',
  'TANZANIA, UNITED REPUBLIC OF',
  'THAILAND',
  'TIMOR-LESTE',
  'TOGO',
  'TOKELAU',
  'TONGA',
  'TRINIDAD AND TOBAGO',
  'TUNISIA',
  // 'TURKEY',
  'TURKMENISTAN',
  'TURKS AND CAICOS ISLAND',
  'TUVALU',
  'UGANDA',
  'UKRAINE',
  'UNITED ARAB EMIRATES',
  'UNITED KINGDOM',
  // 'UNITED STATES',
  'UNITED STATES MINOR OUTLYING ISLANDS',
  'URUGUAY',
  'UZBEKISTAN',
  'VANUATU',
  // 'VENEZUELA',
  'VIET NAM',
  'VIRGIN ISLANDS (BRITISH)',
  'VIRGIN ISLANDS (U.S.)',
  'WALLIS AND FUTUNA',
  'WESTERN SAHARA',
  // 'YEMEN',
  'YUGOSLAVIA',
  'ZAMBIA'
  // ,
  // 'ZIMBABWE'
]
export default countryList.map(x => ({ value: x, label: capitalizer(x) }))
